import { GenericEntity } from './common.model';
import { DictionaryItem } from './dictionary.model';

export enum PartyType {
    NATURAL = 'NATURAL',
    LEGAL = 'LEGAL',
}

export class Party extends GenericEntity {
    typeCode: PartyType = PartyType.NATURAL;
    firstName: string = '';
    lastName: string = '';
    fullName: string = '';
    maidenName: string = '';

    companyName: string = '';
    companyNumber: string = '';
    companyCountry: DictionaryItem = new DictionaryItem('PL');

    pesel: string = '';
    foreigner: boolean = false;
    citizenship: DictionaryItem = new DictionaryItem('PL');
    birthDate: string = null;
    gender: DictionaryItem = new DictionaryItem();
    documentType: DictionaryItem = new DictionaryItem();
    documentNumber: string = null;
    mainAddress: Address = new Address();
    otherCorrespondenceAddress: boolean = false;
    correspondenceAddress: Address = new Address();
    drivingLicenseDate: string = null;
}

export class Address {
    country: DictionaryItem = {code: 'PL'};
    postalCode: string = '';
    city: string = '';
    streetPrefix: DictionaryItem = {code: null};
    streetName: string = '';
    streetNumber: string = '';
    apartmentNumber: string = '';
    fullAddress: string;
}

export class PartyRole extends GenericEntity {
    partyId: number;
    role: string;
}
